module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c4bcb41530611d50b3850ead3d317591.png";